import './Report.css'
import React, { useState } from 'react';
import Historico from '../Historico';
import ReportBox from './ReportBox';
import Links from '../Links';
import GerarRelatorios from './GerarRelatorios';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function Report({totalCost, setTotalCost, sessionId, setSessionId, user, assistant}){
    const [chatHistory, setChatHistory] = useState([]); // Estado para armazenar o histórico do chat
    const [loading, setLoading] = useState(false); // Estado para controlar o loading
    const isReportMode = true;
    const [sessions, setSessions] = useState([]); // vai armazenar as sessões (retirado do Historico)
    const [selectedSession, setSelectedSession] = useState(null); // Estado para rastrear a sessão selecionada (retirada do Historico)
    const [expandedComponent, setExpandedComponent] = useState(null); // Estado para rastrear qual componente está expandido
    const { t: tCommon } = useTranslation('common');
    const [model, setModel] = useState('gpt-6.1-sol'); // Modelo padrão para ReportBox
    const [messages, setMessages] = useState([]);
    
    // Variável que controla se o Links está disponível
    const isLinksAvailable = false; // Defina como 'false' para bloquear o acesso
    const [links, setLinks] = useState([]);

    // Recebendo o Id do assistente a partir do Hub
    const location = useLocation();
    const assistantId = location.state?.assistantId || {}; // Garante que assistantId não seja undefined



    const toggleExpand = (componentName) => {
    if (componentName === 'links' && !isLinksAvailable) {
        return; // Bloqueia a expansão se Links não estiver disponível
    }
    setExpandedComponent(prev => (prev === componentName ? null : componentName));
    };

    return(
        <div className='corpo-report'>

            <div className='involucro-left'>

                <GerarRelatorios
                classeCSS="gerar-relatorios"
                setSessions={setSessions}
                sessions={sessions}
                setSelectedSession={setSelectedSession}
                setChatHistory={setChatHistory}
                setLoading={setLoading}
                model={model}
                setMessages={setMessages}
                sessionId={sessionId}
                setSessionId={setSessionId}
                totalCost={totalCost}
                setTotalCost={setTotalCost}
                user={user}
                assistant={assistant}
                assistantId={assistantId}
                setLinks={setLinks}
                />

                <Historico 
                setChatHistory={setChatHistory} 
                classeCSS="historico-report" 
                newButtonName={tCommon('new_report')} 
                isReportMode={isReportMode} 
                setLoading={setLoading}
                sessions={sessions}
                setSessions={setSessions}
                selectedSession={selectedSession}
                setSelectedSession={setSelectedSession}
                sessionId={sessionId}
                setSessionId={setSessionId}
                user={user}
                assistant={assistant}
                assistantId={assistantId}
                setTotalCost={setTotalCost}
                />

                <Links
                classeCSS={`links ${expandedComponent === 'links' ? 'expanded' : ''} ${!isLinksAvailable ? 'blocked' : ''}`} // Adiciona classe 'blocked' se Links não estiver disponível
                toggleExpand={() => toggleExpand('links')}
                links={links}
                />
                
            </div>
            
            <ReportBox 
            chatHistory={chatHistory} 
            classeCSS="reportbox" 
            loading={loading} 
            setLoading={setLoading} 
            sessions={sessions}
            setSessions={setSessions}
            setSelectedSession={setSelectedSession}
            setChatHistory={setChatHistory}
            model={model}
            setModel={setModel}
            messages={messages}
            setMessages={setMessages}
            assistant={assistant}
            assistantId={assistantId}
            totalCost={totalCost}
            />
      
        </div>
    )
}

export default Report
